import React from 'react';
import Tooltip from './index';
import styles from './BluebookTooltip.css';

const BlueBookTooltip = (props) => {
  const { children, tooltipProps = {} } = props;
  return (
    <Tooltip
      tooltipProps={tooltipProps}
      toolTipContainerClassName={styles['bluebook-tooltip-container']}
      tooltipArrowClassName={styles['bluebook-tooltip-arrow']}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default BlueBookTooltip;
